import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import colors from '../config/colors';
import {
  Button,
  Grid,
  Container,
  Icon,
  Image,
  Transition,
  div
} from 'semantic-ui-react';
import { setNoIndexPageSeo } from '../utils/seo';

class NotFound extends Component {
  componentDidMount() {
    setNoIndexPageSeo({
      title: '404 | Page Not Found | Cannections',
      description: 'The page you are looking for could not be found on Cannections.',
      path: window.location.pathname,
    });
    window.scrollTo(0, 0);
  }
  componentWillMount() {
    // this.setState({ height: window.innerHeight - 70 + 'px' });
  }

  render() {
    return (
      <div style={{ maxWidth: 1200, margin: '150px auto 100px auto' }}>
        <div className='wrapper'>
          <h1 style={{ textAlign: 'center' }}>404</h1>
          <p style={{ textAlign: 'center' }}>
            You lost? ;p
          </p>
        </div>
      </div>

    );
  }
}

const styles = {

}

export default NotFound;
